import React from "react";
import axios from "axios";
import SectionTitle from "../../../assets/components/TitleGroup";
import PlaceholderB from "../../../assets/components/PlaceholderB";
import { SingleButton } from "../../../assets/components/ButtonGroup";
import { useFixedLayout } from "../../../hooks/useFixedLayout";

const AdsRegistConciergeVerify = ({
  phone,
  setPhone,
  pin,
  setPin,
  setConciergePreview,
  goToStep,
  targetConciergeConfirm,
  targetConciergeFindPin,
}) => {
  const { footerRef, bottomSpace } = useFixedLayout();
  const [loading, setLoading] = React.useState(false);

  const isDisabled =
    phone.replace(/\D/g, "").length < 10 || pin.replace(/\D/g, "").length < 4;

  const handleSubmit = async () => {
    if (loading || isDisabled) return;

    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_FASTAPI_ADS_URL}/concierge/user/app-link/verify`,
        {
          app_user_id: Number(localStorage.getItem("user_id")),
          phone: phone.replace(/\D/g, ""),
          pin: pin.replace(/\D/g, ""),
        },
        { headers: { "Content-Type": "application/json" } }
      );
      setConciergePreview(res.data);
      goToStep(targetConciergeConfirm);
    } catch (error) {
      window.alert(
        error?.response?.data?.detail ||
          error?.response?.data?.message ||
          "컨시어지 회원 확인 중 오류가 발생했습니다."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex h-full flex-col">
      <div
        className="flex flex-1 flex-col px-[16px] pt-[16px]"
        style={{ paddingBottom: bottomSpace }}
      >
        <SectionTitle
          title="컨시어지 회원 확인"
          subTitle="본인인증한 휴대폰 번호와 같은 번호, 그리고 컨시어지 PIN 번호를 입력해 주세요."
          className="pb-[40px]"
        />

        <div className="space-y-[12px]">
          <PlaceholderB
            label="휴대폰번호"
            required
            placeholder="숫자만 입력해 주세요"
            type="tel"
            inputMode="numeric"
            pattern="[0-9]*"
            value={phone}
            onChange={(e) =>
              setPhone(e.target.value.replace(/[^0-9]/g, "").slice(0, 11))
            }
          />
          <PlaceholderB
            label="PIN 번호"
            required
            placeholder="숫자 6자리"
            type="tel"
            inputMode="numeric"
            pattern="[0-9]*"
            value={pin}
            onChange={(e) =>
              setPin(e.target.value.replace(/[^0-9]/g, "").slice(0, 6))
            }
          />
        </div>

        <div className="pt-[16px] text-b2 text-text-subtler">
          PIN 번호를 모르신다면{" "}
          <button
            type="button"
            onClick={() => goToStep(targetConciergeFindPin)}
            className="text-text-primary underline underline-offset-[2px]"
          >
            PIN 번호 찾기
          </button>
        </div>
      </div>

      <div ref={footerRef} className="fixed bottom-0 left-0 right-0 bg-surface-default">
        <SingleButton onClick={handleSubmit} disabled={loading || isDisabled}>
          {loading ? "확인 중..." : "컨시어지 정보 확인"}
        </SingleButton>
      </div>
    </div>
  );
};

export default AdsRegistConciergeVerify;
